import React, { useEffect, useState } from "react";
import "../../../../assets/css/loa1.scss";
import Logo from "../../../../assets/img/logo_1.png";
import {
  Employment,
  IncomeProof,
  PriorityBills,
  IncomeExpenseCheck,
  LimitIncreaseStruggling,
  LimitIncreaseReassessment,
  NoSupport,
  HardshipSignals,
  Wellbeing,
} from "../../../../Constants/Constants";

const MeritPageReEngagedHp = ({ category, InputValues, setShowModal }) => {
  const [matchedItems, setMatchedItems] = useState([]);

  const categories = {
    1: Employment,
    2: IncomeProof,
    3: PriorityBills,
    4: IncomeExpenseCheck,
    5: LimitIncreaseStruggling,
    6: LimitIncreaseReassessment,
    7: NoSupport,
    8: HardshipSignals,
    9: Wellbeing,
  };

  const categoryNames = {
    1: "Employment status",
    2: "Loan approval without evidence",
    3: "Priority bills behind",
    4: "No affordability check",
    5: "Offered further credit",
    6: "Overspending",
    7: "No lender support",
    8: "Financial vulnerability indicators",
    9: "Emotional or mental impact",
  };

  useEffect(() => {
    if (!category || !(category in categories)) {
      setMatchedItems([]);
      return;
    }

    const selectedCategory = categories[category];

    // Ensure InputValues is a valid array of objects
    const filteredItems = (Array.isArray(InputValues) ? InputValues : [])
      .map((item) => {
        const id = item.id?.toString();
        const questionText = selectedCategory[id];

        if (questionText) {
          return {
            id,
            description: questionText,
            value: item.value || null,
          };
        }
        return null;
      })
      .filter(Boolean); // remove nulls

    setMatchedItems(filteredItems);
  }, [category, InputValues]);

  return (
    <>
      <div
        className={`modal black-over fade ${category ? "show" : "hide"}`}
        id="sample"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className={`modal-content  goodnews_popup `}>
            <div className="modal-body">
              <div className={`pb-3 text-center px-lg-4 px-md-4  px-sm-01  `}>
                <div className="text-end">
                  <button
                    type="button"
                    className="btn-close close22"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => setShowModal(0)}
                  ></button>
                </div>
                <div className="d-flex justify-content-start">
                  <div className="">
                    <div className="body-class container">
                      <section className="body_all">
                        <div className="page-break" />
                        <table className="adition_page3">
                          <tbody style={{ display: "table" }}>
                            <tr>
                              <td style={{ width: "100%" }}>
                                <center>
                                  <img
                                    src={Logo}
                                    style={{ height: "60px" }}
                                    alt="Logo"
                                  />
                                </center>
                                <h2 className="questh2 mt-2">
                                  {categoryNames[category]}
                                </h2>
                                <br />
                                <div className="text-start">
                                  <ol>
                                    {matchedItems.map((item) => (
                                      <li key={item.id}>
                                        <strong>{item.description}</strong>
                                        <br />
                                        {item.value && (
                                          <>
                                            <br />
                                            <span>{item.value}</span>
                                          </>
                                        )}
                                      </li>
                                    ))}
                                  </ol>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </section>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MeritPageReEngagedHp;
